<!--
 * @Author: FengXiao
 * @Date: 2020-07-27 13:50:15
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-03 00:03:44
-->
<template>
  <div class="recommend-videos-base" v-if="dataList && dataList.length">
    <div class="recommend-videos-title">视频推荐</div>
    <div class="recommend-videos-wrap" @click="onClickItem">
      <div class="recommend-item" v-for="item in dataList" :key="item.id" :data-id="item.id">
        <div class="video-cover no-pointer-evts">
          <img class="video-cover-img" :src="item.cover" alt="" />
          <span class="video_time">{{ item.time }}</span>
        </div>
        <div class="video-info-wrap no-pointer-evts">
          <div class="video_title">{{ item.title }}</div>
          <div class="speaker_name">{{ item.speaker.name }}</div>
          <div class="video_intro-wrap">
            <span v-if="item.category">#{{ item.category }}/</span>
            <span v-if="item.city">{{ item.city }}/</span>
            <span v-if="item.date">{{ item.date }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dataList: this.datas,
    };
  },
  watch: {
    datas(arr) {
      this.dataList = arr;
    },
  },
  methods: {
    onClickItem(e) {
		console.log(e.target.dataset.id)
		// return
      this.$emit('click', e.target.dataset.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.recommend-videos-base {
  background-color: $C1;
  .recommend-videos {
    &-title {
      font-family: HYXinRenWenSongW;
      font-size: 23px;
      color: $C6;
      position: relative;
      line-height: 23px;
      padding: 30px 20px 0px 31px;
      margin-bottom: 30px;
      &:before {
        content: '';
        position: absolute;
        left: 20px;
        bottom: 0;
        width: 3px;
        height: 12px;
        background: $C2;
      }
    }
    &-wrap {
      padding: 0 20px 20px;
    }
  }
  .recommend-item {
    width: 100%;
    border: 1px solid $C11;
    margin-bottom: 17px;
    cursor: pointer;
    transition: box-shadow 0.3s ease-in;
    &:hover {
      box-shadow: 3px 3px 6px $A5;
    }
    &:last-child {
      margin-bottom: 0;
    }
    .video-cover {
      width: 100%;
      height: 164px;
      position: relative;
      .video_time {
        position: absolute;
        right: 10px;
        bottom: 10px;
        font-family: Avenir-Book;
        font-size: 12px;
        color: $C1;
        text-align: left;
        background: $A3;
        padding: 5px 10px;
      }
    }
    .video-info-wrap {
      padding: 10px 14px;
      .video_title {
        cursor: pointer;
        font-size: 17px;
        color: $C6;
        margin-bottom: 10px;
      }
      .speaker_name {
        font-size: 15px;
        line-height: 15px;
        color: $C5;
      }
      .video_intro-wrap {
        margin-top: 24px;
        font-size: 14px;
        color: $C5;
        letter-spacing: 1.7px;
      }
    }
  }
}
</style>
